import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import NewProject from './NewProject';
import * as columns from './ProjectColumns';

class Project extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "PROJECT";
            item.currencyLabel = enums.getLabel(enums.currencies, item.currency);
            item.stateLabel = enums.getLabel(enums.projectStates, item.state);
            item.billingTypeLabel = enums.getLabel(enums.billingTypes, item.billingType);
            return item;
        })
        return data;
    };

    render() {
        return (
            <MainTable
                divClassName="project"
                tableName="Projektek"
                newObjectLabel="Új projekt hozzáadása"
                path='/api/projects'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewProject refresh={refresh} close={close} />} />
        );
    }
}

export default Project;
